var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"aktuelniWrapper"}},_vm._l((_vm.lista),function(strana,index){return _c('img',{key:index,staticClass:"page",attrs:{"src":'/katalog/'+strana}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }